<mat-dialog-content class="mat-dialog-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">private Instant Checkup</h4><i class="fas fa-times pull-right fontL3" (click)="hideModal()"></i>
  </div>
  <div class="modal-body" *ngIf="this.consultationSession.get('PrivateInstantCheckupDebug')">
    <div class="col-xs-12 flex">
      <label class="mt-0 col-xs-3">Detected Issues</label>
      <div class="col-xs-9">
        <div class="col-xs-12" *ngFor="let issues of detectedIssues">{{issues.key}}  {{issues.value}}</div>
      </div>
    </div>
    <div class="col-xs-12 flex">
      <label class="col-xs-3">Active Tree</label>
      <div class="col-xs-9">{{consultationSession.get('PrivateInstantCheckupDebug').activeTree}}</div>
    </div>
    <div class="col-xs-12 flex">
      <label class="col-xs-3">InstantCheckup</label>
      <div class="col-xs-9">
        <div class="col-xs-12" *ngFor="let instantCheckup of consultationSession.get('PrivateInstantCheckupDebug')?.instantCheckups"><a href="/user/instantCheckup/{{instantCheckup?.id}}?username={{consultationSession.get('username')}}" target="_blank">{{instantCheckup?.id}}</a></div>
      </div>
    </div>
    <div class="col-xs-12 flex">
      <label class="col-xs-3">Regimen Id</label>
      <div class="col-xs-9">{{consultationSession.get('PrivateRegimenGiven')}}</div>
    </div>
  </div>
  <div class="col-xs-12 flex">
    <label class="col-xs-3">Tree Paths</label>
    <div class="col-xs-9">
      <div class="col-xs-12" *ngFor="let treePath of consultationSession.get('treePaths'); let isLast = last">{{treePath}} <span *ngIf="!isLast"> ==> </span></div>
    </div>
  </div>
  <div class="col-xs-12 flex mT20 p-0" *ngIf="loadingAnswers">
    <label class="col-xs-3">Answers</label>
    <div class="col-xs-9 p-0"><i class="fa fa-spinner fa-spin"></i></div>
  </div>
  <div class="col-xs-12 flex mT20 p-0" *ngIf="!loadingAnswers && answers.length">
    <label class="col-xs-3">Answers</label>
    <div class="col-xs-9 p-0">
      <div class="col-xs-12 p-0 flex mB5" *ngFor="let answer of answers">
        <div class="col-xs-4 p-0 ellipsis" title="{{answer.key}}">{{answer.key}}:</div>
        <div class="col-xs-8 p-0 ellipsis" title="{{answer.value}}">{{answer.value}}</div>
      </div>
    </div>
  </div>
  <div class="col-xs-12 flex mT20 p-0" *ngIf="temporaryAnswers.length">
    <label class="col-xs-3">Temporary Answers</label>
    <div class="col-xs-9 p-0">
      <div class="col-xs-12 p-0 flex mB5" *ngFor="let answer of temporaryAnswers">
        <div class="col-xs-4 p-0 ellipsis" title="{{answer.key}}">{{answer.key}}:</div>
        <div class="col-xs-8 p-0 ellipsis" title="{{answer.value}}">{{answer.value}} <span class="bold" *ngIf="answer.createdAt">({{answer.createdAt | date: 'MMM d, y'}})</span></div>
      </div>
    </div>
  </div>
</mat-dialog-content>
